
import { defineComponent, reactive } from 'vue'
import { useAsyncTask } from 'vue-concurrency'
import api from '@/estimate/api'
import { Review } from '@/estimate/models'
import { ReviewList } from '@/estimate/components'

export default defineComponent({
  name: 'Review',
  setup() {
    /** お客様の声一覧 */
    const reviewList = reactive<Review[]>([])

    /** ページネーションデータ */
    const pagination = reactive({
      sortBy: 'reviewDay', // 初期ソートカラム
      descending: true, // 初期ソート順 降順=true 昇順=false
      page: 1,
      rowsPerPage: 10,
      rowsNumber: 0,
    })

    /** お客様の声一覧取得タスク */
    const getReviewTask = useAsyncTask(async (signal, query) => {
      return api.review.list({ ...query }).then(res => {
        reviewList.length = 0
        Object.assign(reviewList, res.reviewList)
        Object.assign(pagination, res.pagination)
      })
    })

    function updatePagination(page: string) {
      // ページが同じのときもイベントが呼ばれてしまうための判定
      if (pagination.page !== parseInt(page)) {
        getReviewTask.perform({ filter: { publishFlg: true }, pagination: { ...pagination, page } })
        window.scrollTo({ top: 0, behavior: 'smooth' })
      }
    }

    getReviewTask.perform({ filter: { publishFlg: true }, pagination })

    return { getReviewTask, reviewList, pagination, updatePagination }
  },
  components: { ReviewList },
})
